// import { mutations as MUTATION, actions as ACTION } from "./types";
const actions = {};

export default actions;
